import { z } from 'zod'

import { ASSETCLASSES } from '@/pages/instruments/new-instrument/constants/asset-classes'
import { AXE_FLAGS } from '@/pages/instruments/new-instrument/constants/axe-flags'
import { FACTORS } from '@/pages/instruments/new-instrument/constants/factors'
import { INDEX_TYPES } from '@/pages/instruments/new-instrument/constants/index-types'
import { SUB_FACTORS } from '@/pages/instruments/new-instrument/constants/sub-factors'
import { baseInstrumentSchema } from '@/pages/instruments/new-instrument/schemas/shared/base.schema'

export const indexSchema = baseInstrumentSchema.extend({
  instrument_type: z.literal('index'),
  isin: z.string().length(12, 'Must be exactly 12 characters long.').optional().nullable(),
  index_type: z.enum(INDEX_TYPES),
  asset_class: z.enum(ASSETCLASSES).nullable(),
  factor: z.enum(FACTORS).nullable(),
  sub_factor: z.enum(SUB_FACTORS).nullable(),
  axe_flag: z.enum(AXE_FLAGS).nullable(),
  bbg_ticker: z.string().min(1),
  issuer: z.string().nullable(),
  currency_id: z.number().int().positive(),
  country_id: z.number().int().positive(),
  description: z.string().min(1),
})

export type IndexSchemaType = z.infer<typeof indexSchema>
